module.exports = __webpack_public_path__ + "static/image-beckyball-7cd11b355c76e247d70994ee1c16d09a.jpg";